import { render } from "./NoDataBox.vue?vue&type=template&id=1a492857"
const script = {}

import exportComponent from "/home/forge/crm.thebcr.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__